// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"bcc51ca9","426":"fd3911cc","671":"fd3911cc","686":"fd3911cc","718":"992d06f8","850":"fd3911cc"}[chunkId] + ".chunk.css";
};